package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class LearnedSocietiesResponse(
  val learnedSocieties: List<LearnedSociety>
) {
  @Serializable
  data class LearnedSociety(
    val id: String,
    val name: String,
    val acronym: String?,
    val websiteUrl: String,
    val logoUrl: String?,
    val forStudents: Boolean,
    val medicalSpecialities: List<MedicalSpeciality>,
    val favorite: Boolean
  ) {
    @Serializable
    data class MedicalSpeciality(
      val id: String,
      val name: String
    )
  }
}
